import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ConfigProvider } from './contexts/ConfigContext';
import { CalculatorProvider } from './contexts/CalculatorContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { Layout } from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { CalculatorView } from './views/CalculatorView';
import { ProjectPlannerView } from './views/ProjectPlannerView';
import { ConfigView } from './views/ConfigView';
import LoginView from './views/LoginView';
import RegisterView from './views/RegisterView';
import './styles/variables.css';
import './styles/global.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfigProvider>
          <CalculatorProvider>
            <ProjectProvider>
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<LoginView />} />
                <Route path="/register" element={<RegisterView />} />

                {/* Protected routes */}
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <CalculatorView />
                      </Layout>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/planner"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <ProjectPlannerView />
                      </Layout>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/config"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <ConfigView />
                      </Layout>
                    </ProtectedRoute>
                  }
                />

                {/* Catch all - redirect to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </ProjectProvider>
          </CalculatorProvider>
        </ConfigProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
